<ul fd-list>
  <span fd-form-label i18n-label="XFLD|List header@@recentList.header">Recently Visited</span>
  <table fd-table
    [noBorderX]="true"
    [noBorderY]="true"
    [noOuterBorder]="true"
    aria-label="Without Borders">
    @for (item of storedItems |
      sortBy: false: 'lastVisited' |
      filterBy: path: ['path'] |
      slice:0:(showMore ? maxItemsToShow : initialNumberOfItems); track item) {
      <tr fd-table-row
        (click)="clickOnItem(item)"
        [activable]="true"
        [hoverable]="true">
        <td [noBorderX]="true" [noBorderY]="true" fd-table-cell class="path">{{ item.path }}</td>
        <td [noBorderX]="true" [noBorderY]="true" fd-table-cell class="lastVisited">{{ item.lastVisited }}</td>
      </tr>
    }
    @if ((!(storedItems |
      filterBy: path: ['path'] |
      slice:0:(showMore ? maxItemsToShow : initialNumberOfItems))?.length)) {
      <tr fd-table-row>
        <td fd-table-cell [noData]="true">
          No recently visited paths found
        </td>
      </tr>
    }
  </table>
  @if ((storedItems |
    filterBy: path: ['path'])?.length > initialNumberOfItems) {
    <button fd-button
      [fdType]="'transparent'"
      ariaLabel="Transparent"
      class="link-color"
      [label]="showMoreLessText"
      i18n-label="XBTN|Recent list show more or less@@recentList.showMoreOrLess"
      (click)=showMoreToggle()>
    </button>
  }
</ul>
